var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FetchContainer',{staticClass:"box h-full",attrs:{"entities":_vm.entities}},[_c('CarbonSummed',{attrs:{"from-year":_vm.fromYear,"to-year":_vm.toYear}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }